import { LogEvent, TelemetryEvent, TelemetryEventType } from './types';
const logTypes: TelemetryEventType[] = ['Info', 'Error', 'Performance'];

export const isLogEvent = (event: TelemetryEvent): event is LogEvent => logTypes.includes(event.type);
